__turbopack_context__.v({
  "aspect": "CommitmentHero-module-scss-module__zdPjOW__aspect",
  "calloutWrapper": "CommitmentHero-module-scss-module__zdPjOW__calloutWrapper",
  "commitmentSubnav": "CommitmentHero-module-scss-module__zdPjOW__commitmentSubnav",
  "contentWrapper": "CommitmentHero-module-scss-module__zdPjOW__contentWrapper",
  "ctaWrapper": "CommitmentHero-module-scss-module__zdPjOW__ctaWrapper",
  "left": "CommitmentHero-module-scss-module__zdPjOW__left",
  "navArrow": "CommitmentHero-module-scss-module__zdPjOW__navArrow",
  "pageIdx": "CommitmentHero-module-scss-module__zdPjOW__pageIdx",
  "richHeadline": "CommitmentHero-module-scss-module__zdPjOW__richHeadline",
  "right": "CommitmentHero-module-scss-module__zdPjOW__right",
});
